import { useContext } from 'react';
import { QueryMemberContext } from './Context';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';

const MemberInfo = () => {

    //context
    const { member } = useContext(QueryMemberContext);

    const SiblingsInfo = (props: { siblingsNames: string[] }) => {
        return (
            <strong>
                {props.siblingsNames.length > 0 ? (
                    props.siblingsNames.map((item, i) => {
                        const seperator = props.siblingsNames.length !== i + 1 ? <i>,&nbsp;</i> : '';
                        return <span key={i} className='d-inline-block'>{item}{seperator}</span>
                    })
                ) : <span className='d-inline-block'>Üye Kardeş bilgisi bulunamadı</span>}
            </strong>
        );
    }

    return (
        <Card className={'member-card'} variant="outlined">
            <CardContent>
                <Typography gutterBottom component="h3">
                    Üye Bilgileri
                </Typography>
                <Divider />
                <Typography variant="body2" color="textSecondary" component="div">
                    {
                        member && member.goldenCode !== '' ?
                            <Box py={1}>
                                <table className="member-info-table">
                                    <tbody>
                                        <tr>
                                            <td>Adı:</td>
                                            <td>
                                                <strong>{member.name} {member.surname}</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Doğum Tarihi:</td>
                                            <td>
                                                <strong>{member.birthDate}</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Çalıştığı Şirket:</td>
                                            <td>
                                                <strong>{member.companyName}</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Üye Numarası: </td>
                                            <td>
                                                <strong>{member.goldenCode}</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Üyelik Tipi:</td>
                                            <td>
                                                <strong>{member.memberTypeDescription}</strong>
                                            </td>
                                        </tr>
                                        {
                                            member.hasSiblingRelationPerm &&
                                            <tr>
                                                <td>Kardeş Bilgisi:</td>
                                                <td>
                                                    <SiblingsInfo siblingsNames={member.siblingsNames} />
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </Box>
                            : null
                    }
                    {/* <Alert style={{ marginTop: '5px' }} severity={data.resultCode === '1' ? 'info' : 'error'}>
                        {data.description}
                    </Alert> */}
                </Typography>
            </CardContent>
        </Card>
    )
}

export default MemberInfo;
